<template>
  <v-combobox
    v-model="selectedProjectId"
    :search-input.sync="projectSearch"
    :items="projects"
    :loading="projectsLoading"
    :filter="projectLookup"
    label="Project suchen"
    item-text="desc"
    clearable
    outlined
    solo
    @change="inputChanged"
  ></v-combobox>
</template>

<script>
import { debounce } from 'lodash';
import { HTTP } from '@/main/httpClient.js';

export default {
  name: 'SearchProjectInput',
  props: {
    projectFilter: {
      type: Function,
      required: false,
      default: null
    }
  },
  data: () => ({
    selectedProjectId: null,
    projectsLoading: false,
    projectSearch: '',
    projects: [],
    debounceSearch: null,
    abortController: null,
    blockSearch: false
  }),
  watch: {
    projectSearch(search) {
      if (this.blockSearch) {
        this.blockSearch = false;
        return;
      }
      if (!search) return;
      if (Number.isInteger(Number.parseInt(search))) {
        const projectId = Math.abs(Number.parseInt(search));
        this.debounceSearch = this.debounceProjectSearch(projectId, true);
      } else if (search.length < 3) return;
      else {
        this.debounceSearch = this.debounceProjectSearch(search, false);
      }

      this.debounceSearch();
    }
  },
  methods: {
    debounceProjectSearch(search, isProjectId) {
      if (this.debounceSearch) {
        this.debounceSearch.cancel();
      }
      return debounce(
        function () {
          this.searchProject(search, isProjectId);
        },
        isProjectId ? 150 : 250
      );
    },
    projectLookup(item, queryText, itemText) {
      if (Number.isInteger(Number.parseInt(queryText))) {
        return item.projektId === Number.parseInt(queryText);
      }

      return itemText.toLowerCase().includes(queryText.toLowerCase());
    },
    inputChanged(project) {
      this.blockSearch = true;
      this.$emit('projectSelected', project);
    },
    searchProject(search, isProjectId) {
      if (this.debounceTask) {
        this.debounceTask.cancel();
      }

      this.projectsLoading = true;

      if (this.abortController !== null) this.abortController.abort();
      this.abortController = new AbortController();

      HTTP({
        method: 'GET',
        url: '/past/geo/project-names?search=' + search,
        signal: this.abortController.signal
      })
        .then(({ status, data }) => {
          if (status === 200) {
            const projects =
              this.projectFilter !== null ? this.projectFilter(data) : data;
            this.projects = projects.map((i) => {
              i.desc = `${i.projektId} - ${i.name}`;
              return i;
            });
          }
        })
        .finally(() => {
          this.projectsLoading = false;
        });
    }
  }
};
</script>
